<app-not-authorized-notice has="userRoleManagement"></app-not-authorized-notice>

@if (canEditUsers) {
	<app-navigation-header title="Add Users" i18n-title="@@roleDetailADdUserMainTab-addUsersTitle" svgName="sl-add">
		<div class="mat-stepper-navigator">
			@if (stepperRef.selectedIndex !== 1) {
				<button
					mat-flat-button
					class="primary-stepper-button"
					[disabled]="!isValid()"
					(click)="moveNext(stepperRef)"
					data-automation-id="role-detail-add-continue-button"
					i18n="@@roleDetailAddUserMainTab-continueButton"
				>
					Continue
				</button>
			}
		</div>
		<mat-horizontal-stepper linear #stepperRef>
			<mat-step>
				<ng-template matStepLabel>Add Users</ng-template>
				<app-add-role-users [editRole]="editRole" [requireUsers]="true"> </app-add-role-users>
			</mat-step>
			<mat-step>
				<ng-template matStepLabel>Confirmation</ng-template>
				<app-role-detail-confirmation
					[createRoleRequestStatusEvent]="updateRoleRequestStatusEvent"
					[companyId]="companyId"
					[isActiveCompany]="isActiveCompany"
					[roleId]="roleId"
				>
				</app-role-detail-confirmation>
			</mat-step>
		</mat-horizontal-stepper>
	</app-navigation-header>
}
